import React, { useEffect, useState } from 'react';

import { VinculoTableRow } from './auxiliarMeusDados';
import SubAbas from './subabas';
import BarraInferiorBotoes from '../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../components/BarraSubAbas';
import BoxConteudo from '../../../components/BoxConteudo';
import ContainerConteudo from '../../../components/ContainerConteudo';
import CustomCol from '../../../components/CustomCol';
import CustomRow from '../../../components/CustomRow';
import Input from '../../../components/InputNew';
import Select from '../../../components/InputNew/Select';
import Modal from '../../../components/Modal';
import VinculoUsuarioListagem from '../../../components/VinculoUsuario/listagem';
import WorkspaceBotoes from '../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../components/WorkspaceFicha';
import { getUser } from '../../../modules/contexts/Auth/RequireAuth';
import { usePasswordValidation } from '../../../modules/hooks/usePasswordValidation';
import { UsuarioVinculo } from '../../../modules/types/UsuarioVinculo';
import { useCor } from '../../../services/enum/useCorPele';
import { useGeneros } from '../../../services/enum/useGeneros';
import { useOrgaoOrigem } from '../../../services/enum/useOrgaoOrigem';
import { useTipoVinculo } from '../../../services/enum/useTipoVinculo';
import httpClient from '../../../services/httpClient';
import { getUserData } from '../../../services/userService';
import { useUserIdData } from '../../../services/usuario/useUserIdData';
import { getUserPapel } from '../../../services/usuario/userService';
import { getUsuarioVinculosByUsuarioId } from '../../../services/usuario/usuarioVinculoService';
import { formatDateSimp } from '../../../utils/functions';
import { swal, swalAttention, swalAtualizacao } from '../../../utils/swal';

const MeusDadosUsuario: React.FC = () => {
  const { formData, setFormData } = useUserIdData();
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleModal = () => setShowModal((prev) => !prev);

  const [senha, setSenha] = useState<string>('');
  const [confirmaSenha, setConfirmaSenha] = useState<string>('');

  const [validLength, passwordMatch] = usePasswordValidation({
    firstPassword: senha,
    secondPassword: confirmaSenha,
  });

  const [passwordDigits, setPasswordDigits] = useState<number>(0);

  const [vinculos, setVinculos] = useState<UsuarioVinculo[]>([]);

  const validaSenhaTamanho = () => {
    if (passwordDigits > 0 && !validLength) {
      console.log('Senha inválida: comprimento insuficiente');
      swal(
        'error',
        'Senha inválida',
        'A senha deve conter no mínimo 6 caracteres!',
      );
      setSenha('');
      handleModal();
    }
  };

  const validaSenhaConfirma = () => {
    if (passwordDigits >= 6 && !passwordMatch) {
      console.log('Senha inválida: as senhas não coincidem');
      swal('error', 'Senha inválida', 'As senhas digitadas não são iguais!');
      setConfirmaSenha('');
      handleModal();
    }
  };

  const tituloModal = 'Alterar Senha';
  const iconeModal = 'key';

  const generos = useGeneros();
  const cores = useCor();
  const orgaoOrigem = useOrgaoOrigem();
  const tipoVinculo = useTipoVinculo();

  const handleChange = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
      | { name: string; value: any },
  ) => {
    const { name, value } = 'target' in event ? event.target : event;
    const enumFields = [
      'genero',
      'cor',
      'tipoVinculo',
      'orgaoOrigem',
      'unidadeDAF',
    ];
    const newValue = enumFields.includes(name) ? parseInt(value, 10) : value;

    setFormData((prev) => {
      const updatedData = {
        ...prev,
        [name]: newValue,
      };

      // Limpa campos (tipoVinculo e orgaoOrigem)
      if (name === 'tipoVinculo' && ['0', '1'].includes(String(value))) {
        updatedData.orgaoOrigem = '';
        updatedData.outroOrgao = '';
      }

      if (name === 'orgaoOrigem' && String(newValue) !== '6') {
        updatedData.outroOrgao = '';
      }

      return updatedData;
    });
  };
  const fetchVinculos = async () => {
    try {
      const userVinculosData = await getUsuarioVinculosByUsuarioId(
        parseInt(userID, 10),
      );
      setVinculos(userVinculosData);
    } catch (error) {
      console.error('Erro ao buscar vínculos do usuário:', error);
    }
  };
  const handleSenhaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSenha(e.target.value);
    setPasswordDigits(e.target.value.length);
  };

  const handleConfirmaSenhaChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setConfirmaSenha(e.target.value);
  };

  const user = getUser();
  const userID = user.sub;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userData = await getUserData(userID);
        setFormData(userData);
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };
    fetchData();
    fetchVinculos();
  }, [userID, setFormData]);

  // Validação
  const validateForm = (form: any) => {
    const errors: string[] = [];

    if (form.tipoVinculo === '0' || !form.tipoVinculo) {
      errors.push('O campo <b>Tipo de vínculo</b> é obrigatório.');
    }

    if (Number(form.tipoVinculo) > 1 && Number(form.orgaoOrigem) === 0) {
      errors.push(
        'Órgão de <b>Origem</b> é obrigatório para o tipo de vínculo selecionado.',
      );
    }

    if (Number(form.orgaoOrigem) === 6 && !form.outroOrgao) {
      if (form.outroOrgao === '') {
        errors.push(
          'Informe o campo <b>Outro órgão</b> quando o órgão de origem for "Outro".',
        );
      }
    }

    if (form.emailPessoal) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(form.emailPessoal)) {
        errors.push('O campo <b>EMAIL</b> deve conter um email válido.');
      }
    } else {
      errors.push('O campo <b>EMAIL</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>'));
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const updateData = async () => {
    const validateFormResult = validateForm(formData);

    if (!validateFormResult) {
      return;
    }

    try {
      // Normaliza os dados para envio
      const sanitizedData = {
        ...formData,
        emailInstitucional: formData.emailPessoal,
        tipoVinculo: formData.tipoVinculo ?? 0,
        orgaoOrigem: formData.orgaoOrigem
          ? parseInt(formData.orgaoOrigem, 10)
          : 0,
        outroOrgao: formData.outroOrgao || '',
      };

      //console.log('Dados enviados para a API:', sanitizedData);
      console.log('ID do usuário:', userID);
      console.log('Dados enviados para a API:', sanitizedData);
      const response = await httpClient.patch(
        `/api/users/${userID}`,
        sanitizedData,
      );

      swalAtualizacao('Sucesso', response.data.message);
      // setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      console.error('Erro ao atualizar dados:', error);
      swal(
        'error',
        'Algo deu errado... Alterações não foram realizadas com sucesso. Tente novamente.',
        'error',
      );
    }
  };

  const updateSenha = async () => {
    try {
      if (!validLength || !passwordMatch)
        throw new Error(
          'As senhas devem ter no mínimo 6 caracteres e serem iguais.',
        );

      console.log('Atualizando senha para:', senha);

      const response = await httpClient.patch(`/api/users/${userID}/senha`, {
        novaSenha: senha,
      });

      if (response.status === 200) {
        setShowModal(false);
        setSenha('');
        setConfirmaSenha('');
        swalAtualizacao('Sucesso', response.data.message);
      } else {
        throw new Error('Erro ao atualizar senha');
      }
    } catch (error) {
      console.error('Erro ao alterar senha:', error);
      swal(
        'error',
        'Erro ao alterar senha',
        'As senhas devem ter no mínimo 6 caracteres e serem iguais.',
      );
    }
  };

  useEffect(() => {
    if (userID) {
      // Certifique-se de substituir `userID` pela variável/condição apropriada
      const fetchData = async () => {
        try {
          // Obtém os dados do usuário e atualiza o estado
          const userData = await getUserData(userID);
          setFormData(userData);

          // Caso necessário, descomente e ajuste estas chamadas:
          const userPapelData = await getUserPapel(userID);

          if (userPapelData.length > 0) {
            setFormPapel((prevState) => ({
              ...prevState,
              papelUsuario: userPapelData[0].papelUsuario,
            }));
          }
        } catch (error) {
          console.error('Erro ao obter dados:', error);
        }
      };
      fetchData();
    }
  }, [userID]); // Dependências ajustadas

  const [formPapel, setFormPapel] = useState({
    papelUsuario: 0,
    dataInicio: '',
    dataFim: '',
    observacoes: '',
    usuarioRegistroId: userID,
    papelId: null,
    status: 'N',
  });

  useEffect(() => {
    // console.log('isUserTecnico:', isUserTecnico);
  }, [formPapel.papelUsuario]);

  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';

    setStatusStyle({
      backgroundColor: formData.stRegistroAtivo === 'S' ? verde : vermelho,
    });
  }, [formData.stRegistroAtivo]);

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        <WorkspaceFicha>
          {/* Dados do Usuário */}
          <BoxConteudo boxTitulo="Dados do Usuário">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol
                width="200px"
                helpText={
                  formData.stRegistroAtivo === 'S'
                    ? 'Usuário POSSUI VÍNCULO ativo.'
                    : 'Usuário NÃO POSSUI VÍNCULO ativo.'
                }
              >
                <Input
                  name="stRegistroAtivo"
                  value={formData.stRegistroAtivo === 'S' ? 'Ativo' : 'Inativo'}
                  label="Status"
                  onChange={handleChange}
                  style={statusStyle}
                  readonly
                />
              </CustomCol>
              <CustomCol width="180px">
                <Input
                  name="cpf"
                  mascara="cpf"
                  value={formData.cpf}
                  id="cpf"
                  label="CPF"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="nomeCompleto"
                  value={formData.nomeCompleto}
                  id="nome"
                  label="Nome completo"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataNascimento"
                  type="date"
                  value={formData.dataNascimento}
                  id="dataNascimento"
                  label="Data de nascimento"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="200px">
                <Select
                  name="genero"
                  value={formData.genero.toString()}
                  onChange={handleChange}
                  options={generos}
                  label="Gênero"
                />
              </CustomCol>
              <CustomCol width="200px">
                <Select
                  name="cor"
                  value={formData.cor.toString()}
                  onChange={handleChange}
                  options={cores}
                  label="Cor da pele"
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="200px">
                <Input
                  name="celular"
                  mascara="celular"
                  value={formData.celular}
                  id="celular"
                  label="Celular"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="180px">
                <Input
                  name="ramal"
                  mascara="9999"
                  value={formData.ramal}
                  id="ramal"
                  label="Ramal"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="220px">
                <Select
                  name="tipoVinculo"
                  value={formData.tipoVinculo}
                  onChange={handleChange}
                  options={tipoVinculo}
                  label="Vínculo funcional"
                  required
                />
              </CustomCol>

              <CustomCol width="380px">
                <Select
                  name="orgaoOrigem"
                  value={formData.orgaoOrigem}
                  options={orgaoOrigem}
                  label="Órgão de origem"
                  onChange={handleChange}
                  disabled={['0', '1'].includes(String(formData.tipoVinculo))}
                  required={Number(formData.tipoVinculo) > 1}
                />
              </CustomCol>

              <CustomCol>
                <Input
                  name="outroOrgao"
                  value={formData.outroOrgao}
                  id="outroOrgao"
                  label="Outro órgão"
                  onChange={handleChange}
                  readonly={!['6'].includes(String(formData.orgaoOrigem))}
                  required={Number(formData.orgaoOrigem) === 6}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  name="emailPessoal"
                  value={formData.emailPessoal}
                  id="emailPessoal"
                  label="Email"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              {/* <CustomCol>
                <Input
                  name="emailInstitucional"
                  value={formData.emailInstitucional}
                  id="emailInstitucional"
                  label="Email institucional"
                  onChange={handleChange}
                />
              </CustomCol> */}
              <CustomCol>
                <Input
                  name="linkedin"
                  value={formData.linkedin}
                  id="linkedin"
                  label="LinkedIn"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="lattes"
                  value={formData.lattes}
                  id="lattes"
                  label="Lattes"
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {/* Vínculos do Usuário */}
          <BoxConteudo boxTitulo="Vínculos do Usuário">
            <VinculoUsuarioListagem fichaID={userID} />
          </BoxConteudo>

          {/* Modal de Alteração de Senha */}
          <Modal
            icone={iconeModal}
            tituloModal={tituloModal}
            open={showModal}
            onHide={handleModal}
            modalSize="medio"
          >
            <div className="d-flex form flex-column justify-content-center align-items-center gap-4 m-3">
              <Input
                name="senha"
                id="senha"
                value={senha}
                label="Nova Senha"
                onChange={handleSenhaChange}
                onBlur={validaSenhaTamanho}
                type="password"
              />
              <Input
                name="confirmaSenha"
                value={confirmaSenha}
                label="Confirma Senha"
                id="confirmaSenha"
                onChange={handleConfirmaSenhaChange}
                type="password"
                onBlur={validaSenhaConfirma}
              />
              <WorkspaceBotoes
                cancelar
                onClickCancelar={handleModal}
                save
                onClickSave={updateSenha}
              />
            </div>
          </Modal>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          save
          onClickSave={updateData}
          senha
          onClickSenha={handleModal}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default MeusDadosUsuario;
